import { useCallback, useState } from "react";

export function useTherapyWizardState({ onAfterSuccess } = {}) {
  const [wizardState, setWizardState] = useState({ open: false, data: null });

  const openWizard = useCallback(() => {
    setWizardState({ open: true, data: null });
  }, []);

  const handleEditTherapy = useCallback((therapy) => {
    setWizardState({ open: true, data: therapy });
  }, []);

  const closeWizard = useCallback(() => {
    setWizardState({ open: false, data: null });
  }, []);

  const handleTherapyCreated = useCallback(() => {
    onAfterSuccess?.();
    closeWizard();
  }, [onAfterSuccess, closeWizard]);

  return {
    wizardState,
    openWizard,
    closeWizard,
    handleEditTherapy,
    handleTherapyCreated,
  };
}
